module.exports = __webpack_public_path__ + "static/img/bg_share_first.479dbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/riverMountain-3/bg_share_first.png
// module id = xdr4
// module chunks = 1